import AttendeesSection from './AttendeesSection';

export default AttendeesSection;
